export const zhCN = {
    entities: {
        PageManage: {
            pagesType: '页面类型',
            pagesName: '页面名称',
            enabled: '启用',
            template: '模板来源',
            createTime: '创建时间',
            lastedModifyTime: '修改时间',
        },
        TemplateManage: {
            templateName: '模板名称',
            templateType: '模板类型',
            sorting: '排序',
            previewImage: '预览图',
            enabled: '启用',
            FixedPageStructure: '固定页面结构',
        },
    },
    rules: {
        PageManage: {
            nameRequired: '请输入页面名称.',
            nameLength: '最多可输入16个字符.',
        },
        TemplateManage: {
            nameRequired: '请输入模板名称.',
            nameLength: '最多可输入16个字符.',
        },
    },
    components: {
        NavMenu: {
            operationsManagement: '运营管理',
            pagesManagement: '页面管理',
            templatesManagement: '模板管理',
            language: '多语言',
        },
        PageManage: {
            createPage: '创建页面',
            setting: '设置',
            decorate: '装饰',
            preview: '预览',
            delete: '删除',
            setPage: '设置页面',
        },
        TemplateManage: {
            createTemplate: '新建模板',
            setTemplate: '设置模板',
            decorate: '装饰模板',
            preview: '预览模板',
            select: '选择模板',
        },
        PageDesign: {
            settingInformation: '点击设置页面信息',
            removeConfirm: '确定移除当前组件吗',
            addComponent: '新增组件',
            pageSetting: '页面设置',
        },
        PageDesignRoot: {
            shareInformation: '分享信息',
            basicInformation: '基础信息',
            title: '标题',
            description: '描述',
            image: '图片',
            backgroundColor: '背景',
            miniCart: '小购物车',
            backToTop: '回到顶部',
        },
        ComponentSelector: {
            title: '标题',
            text: '文本',
            nav: '导航',
            products: '商品',
            imageAd: '图片广告',
            divider: '辅助线',
            space: '辅助空白',
            noticeBar: '通知栏',
            searchBar: '搜索框',
            showcase: '橱窗',
        },
        Title: {
            content: '标题内容',
            color: '标题颜色',
            size: '标题大小',
            contentRequired: '请输入标题内容.',
            align: '对齐方式',
            left: '左对齐',
            right: '右对齐',
            center: '居中',
        },
        Divider: {
            style: '边框样式',
            color: '边框颜色',
            margin: '边距',
            none: '无边距',
            solid: '实线',
            dashed: '虚线',
            dotted: '点线',
            space: '左右留白',
        },
        ImageAd: {
            selectTemplate: '选择模板',
            fillStyle: '填充方式',
            pageMargin: '页面边距',
            imageMargin: '图片边距',
            borderRadius: '图片圆角',
            blank: '留白',
            fill: '填充',
            addImage: '新增广告位',
            imageSize: '图片宽度建议为750px',
            tips: '每行最多添加 {{max}} 个商品广告位，可拖拽调整顺序。',
        },
        Nav: {
            name: '导航名称',
            selectType: '选择类型',
            number: '导航数量',
            graphic: '图文导航',
            text: '文字导航',
            style: '导航样式',
            unfold: '展开（展示全部）',
            fold: '折叠（展示一行）',
            color: '导航颜色',
            pageMargin: '页面边距',
            addNav: '新增分类导航项',
            imageSize: '图片尺寸建议为200px*200px',
            tips: '最多添加 {{max}} 个导航图片，可拖拽调整顺序。',
        },
        NoticeBar: {
            color: '字体颜色',
            backgroundColor: '背景颜色',
            icon: '左侧图片',
            content: '通知信息',
            addNoticeBar: '新增通知消息',
            tips: '最多添加 {{max}} 个通知信息，可拖拽调整顺序。',
        },
        SearchBar: {
            keywords: '搜索热词',
            shape: '框体样式',
            square: '方形',
            round: '圆形',
            backgroundColor: '背景颜色',
            shapeColor: '框体颜色',
            textAlign: '文本位置',
            left: '居左',
            center: '居中',
            textColor: '文本颜色',
            addSearchWord: '新增搜索热词',
            searchTips: '搜索框默认展示第一个热词，其他搜索词将以标签形式显示在搜索页中',
            tips: '最多添加 {{max}} 个搜索热词，可拖拽调整顺序。',
        },
        Space: {
            space: '空白高度',
        },
        Text: {
            contentSet: '内容设置',
            content: '文字内容',
            color: '文字颜色',
            size: '文字大小',
            textAlign: '对齐方式',
            left: '左对齐',
            center: '居中',
            right: '右对齐',
            targetLink: '跳转链接',
            contentRequired: '请输入内容.',
        },
        Products: {
            showStyle: '展示样式',
            products: '商品',
            content: '显示内容',
            buy: '购买按钮',
            name: '商品名称',
            price: '商品价格',
            list: '列表',
            card: '卡片',
            scroll: '横向滚动',
            dragTips: '可拖动右侧商品调整排列顺序',
            marketPrice: '市场价格',
            pointPrice: '积分价格',
        },
        Tools: {
            reset: '重置',
            effectiveTime: '生效时间',
            linkType: '链接类型',
            linkTarget: '链接目标',
            modify: '修改',
            select: '选择',
            selectProduct: '选择商品',
            set: '设置',
        },
    },
    common: {
        keywords: '关键字',
        tableAction: '操作',
        search: '查询',
        cancel: '取消',
        submit: '提交',
        ok: '确定',
        save: '保存',
        goBack: '返回',
        saveSuccess: '保存成功',
        upload: '上传',
    },
};
